module.exports = __webpack_public_path__ + "static/media/tarmac.65e1ce53.png";